import { useState, useRef, useEffect } from 'react';
import avatarLogo from 'assets/images/user-avatar.jpg';
import raintreeLogo from 'assets/images/Raintree_logos_blackpng.png';
import { useLocation, useNavigate } from "react-router-dom";
import '../assets/css/profile.css';
import {
    Box,
    ClickAwayListener,
    Divider,
    Grid,
    Link,
    Paper,
    Popper,
    Stack,
    Typography,
    Badge,
    useMediaQuery,
    IconButton
} from '@mui/material';
import { IconBell } from '@tabler/icons';
import { useTheme } from '@mui/material/styles';
import Transitions from '../ui-component/extended/Transitions';
import MainCard from '../ui-component/cards/MainCard';
import PerfectScrollbar from 'react-perfect-scrollbar';
import axiosInstance from '../custom-axios';
import UserNotificationList from '../views/user-components/pages/UserNotificationList';
import { toast } from 'react-toastify';
// import $ from 'jquery';

// const pages = ['Products', 'Pricing', 'Blog'];
// const settings = ['Logout']; // add multiple li item in after login in to dashboard.

const HeaderLayout = ({ setIsComponentLoading }) => {
    const theme = useTheme();
    const userId = localStorage.getItem('user_id');
    const loginType = localStorage.getItem('login_type');
    const prevLoginType = localStorage.getItem('prev_login_type');
    const comingFromLink = localStorage.getItem('coming_from');// set from client-list
    const navigate = useNavigate();
    /*const location = useLocation(); */
    const matchesXs = useMediaQuery(theme.breakpoints.down('md'));

    const [profileProgress, setProfileProgress] = useState('');
    const [open, setOpen] = useState(false);
    const [value, setValue] = useState('');
    const [userNotificationCount, setUserNotificationCount] = useState(0);
    const [notificationList, setNotificationList] = useState();
    const [userData, setUserData] = useState([]);

    /**
     * anchorRef is used on different componets and specifying one type leads to other components throwing an error
     * */
    const anchorRef = useRef(null);

    const handleToggle = () => {
        setOpen((prevOpen) => !prevOpen);
    };

    const handleClose = (event) => {
        if (anchorRef.current && anchorRef.current.contains(event.target)) {
            return;
        }
        setOpen(false);
    };

    const prevOpen = useRef(open);

    const handleChange = (event) => {
        if (event?.target.value) setValue(event?.target.value);
    };

    const fetchNotificationList = async () => {
        try {
            const response = await axiosInstance.get(`api/user-notification/${userId}`);

            if (response.status === 200) {
                setNotificationList(response.data);
            }
        } catch (error) {
            // console.error(error.message);
        }
    };


    // : AFTER GOING TO DASHBOARD RETURN TO PERSON WHILE YOU CLICKED ON CLIENTS.
    const onClickComponent = (id) => {
        if (setIsComponentLoading) {
            setIsComponentLoading(id);
        } else {
            navigate('/admin_dashboard');
        }
    };

    async function fetchProgress() {
        try {
            let response = await axiosInstance.get(`api/user_progress/${userId}`);
            setProfileProgress(response.progress);
        } catch (error) { }
    }

    async function fetchUserDetails() {

        try {

            let response = await axiosInstance.get(`api/get-user-data/${userId}`);

            if (response.status === 200) {
                setUserData(response.data);
            }

        } catch (error) { }
    }

    async function fetchUserNotificationCount() {
        try {
            let response = await axiosInstance.get(`api/user-notification-count/${userId}`);
            setUserNotificationCount(response.data);
        } catch (error) { }
    }

    function notificationsLabel(count) {
        if (count === 0) {
            return 'no notifications';
        }
        if (count > 10) {
            return 'more than 10 notifications';
        }
        return `${count} notifications`;
    }

    const clickAllNotification = async () => {
        try {
            let response = await axiosInstance.post(`api/set-notification-status-all/${userId}`);
            // setProfileProgress(response.progress);
            if (response.success) {
                fetchUserNotificationCount();
            }
        } catch (error) { }
    };

    const clickMainMenu = () => {
        navigate('/client-list', { state: { filter: 'nonreg' } })

        if (userId) {
            localStorage.removeItem('user_id')
        }
    }

    const navigateClientList = () => {
        localStorage.setItem('login_type', prevLoginType)

        if (userId) {
            localStorage.removeItem('user_id')
            localStorage.removeItem('dashboard_login')
            localStorage.removeItem('coming_from')
            // localStorage.removeItem('prev_login_type')
        }
        navigate('/client-list', { state: { filter: 'reg' } })
    }


    const navigateAdminClientList = () => {
        localStorage.setItem('login_type', prevLoginType)

        if (userId) {
            localStorage.removeItem('user_id')
            localStorage.removeItem('dashboard_login')
            localStorage.removeItem('coming_from')
            // localStorage.removeItem('prev_login_type')
        }
        navigate('/admin/register', { state: { filter: 'reg' } })
    }

    const logout = async () => {
        // const redirectLink = (prevLoginType === 'portfolio_manager') || (prevLoginType === 'dashboard_admin') ? '/pm-dashboard-login' : '/'


        try {
            const endPoint = 'api/logout';
            await axiosInstance.post(endPoint).then((response) => {

                if (response.status === 'success') {
                    localStorage.clear();
                    window.location.href = response.redirect_url;
                    // navigate(response.redirect_url);
                    // localStorage.setItem('redirect_url', response.redirect_url);


                } else {
                    toast.error('An error occurred while logging out. Please try again.');
                }
            });

        } catch (err) {

            toast.error('An error occurred while logging out. Please try again.');
        }
    };

    function NotificationPopper() {
        return (
            <>
                <Popper
                    placement={matchesXs ? 'bottom' : 'bottom-end'}
                    open={open}
                    anchorEl={anchorRef.current}
                    role={undefined}
                    transition
                    disablePortal
                    popperOptions={{
                        modifiers: [
                            {
                                name: 'offset',
                                options: {
                                    offset: [matchesXs ? 5 : 0, 20]
                                }
                            }
                        ]
                    }}
                >
                    {({ TransitionProps }) => (
                        <Transitions position={matchesXs ? 'top' : 'top-right'} in={open} {...TransitionProps}>
                            <Paper>
                                <ClickAwayListener onClickAway={handleClose}>
                                    <MainCard border={false} elevation={16} content={false} boxShadow shadow={theme.shadows[16]}>

                                        <Grid container direction="column" spacing={2}>
                                            <Grid item xs={12} sx={{ minWidth: '275px' }}>
                                                <Grid container justifyContent="space-between" sx={{ pt: 2, px: 2 }}>
                                                    <Grid item>
                                                        <Stack direction="row" spacing={2}>
                                                            <Typography variant="subtitle1">All Notification</Typography>
                                                            {/*<Chip
                                                                size="small"
                                                                label={userNotificationCount}
                                                                sx={{
                                                                    color: theme.palette.background.default,
                                                                    bgcolor: theme.palette.warning.dark
                                                                }}
                                                            />*/}
                                                        </Stack>
                                                    </Grid>

                                                    {/*  USED Link FROM REACT ROUTER DOM TO AVOID RELOAD PAGE */}

                                                    {userNotificationCount > 0 ?
                                                        <Grid item onClick={clickAllNotification}>
                                                            <Typography
                                                                component={Link}
                                                                to="#"
                                                                variant="subtitle2"
                                                                color="primary"
                                                                className='cursor-pointer'
                                                            >
                                                                Mark as all read
                                                            </Typography>
                                                        </Grid>
                                                        : null}
                                                </Grid>
                                            </Grid>

                                            <Divider className="divider" />

                                            {/* {userNotificationCount > 0 ? */}

                                            <Grid item xs={12} className="padding5px">
                                                <Box sx={{ height: "100%", overflowX: "hidden" }}>
                                                    <PerfectScrollbar>
                                                        <UserNotificationList
                                                            closePoper={setOpen}
                                                            fetchNotificationListApi={fetchNotificationList}
                                                            notificationList={notificationList}
                                                        />
                                                    </PerfectScrollbar>
                                                </Box>
                                            </Grid>


                                            {/* : <Grid item xs={12}>
                                                <Typography className='text-center padding10px padding-top0px'> No Notification</Typography>
                                            </Grid>
                                            } */}
                                        </Grid>

                                        {/*<Divider />
                                        <CardActions sx={{ p: 1.25, justifyContent: 'center' }}>
                                            <Button size="small" disableElevation>
                                                View All
                                            </Button>
                                        </CardActions>*/}
                                    </MainCard>
                                </ClickAwayListener>
                            </Paper>
                        </Transitions>
                    )}
                </Popper >
            </>
        );
    }


    useEffect(() => {
        // fetchProgress();
        // fetchUserNotificationCount();

        if (userId) {
            fetchUserDetails()
        }

        if (prevOpen.current === true && open === false) {
            anchorRef.current.focus();
        }
        prevOpen.current = open;
    }, [open]);

    // useEffect(() => {
    //     fetchNotificationList()
    // }, [])

    return (
        <>
            <header className="app-header top-bar-01">
                <nav className="navbar navbar-expand-md">
                    <div className="container-fluid">
                        <a href="/" className={`nav-link sidebar-toggle cursor-pointer  ${profileProgress >= 5 ? 'd-none' : ''}`}>
                            <span className="navbar-toggler-icon" />
                        </a>
                        <div className="navbar-header d-flex align-items-center justify-content-start">
                            <a className="navbar-brand" href="/">
                                <img src={raintreeLogo} className="img-fluid logo width170px" alt="logo" />
                            </a>
                        </div>

                        <button
                            className="navbar-toggler"
                            type="button"
                            data-bs-toggle="collapse"
                            data-bs-target="#navbarSupportedContent"
                            aria-controls="navbarSupportedContent"
                            aria-expanded="false"
                            aria-label="Toggle navigation"
                        >
                            <span className="navbar-toggler-icon" />
                        </button>

                        <div className="collapse navbar-collapse" id="navbarSupportedContent">
                            <div className="navigation d-flex">
                                <ul className="navbar-nav nav-left">
                                    <li className="nav-item">
                                        <a className={`cursor-pointer nav-link sidebar-toggle ${profileProgress == 5 ? 'd-block' : ''}`}>
                                            <i className="fa-solid fa-sliders" />
                                        </a>
                                    </li>
                                </ul>
                                <ul className="navbar-nav nav-right">
                                    {/*======================= || NOTIFICATION ||==========================*/}
                                    {profileProgress == 5 ? (
                                        <li>
                                            <div className="d-flex align-items-center justify-content-around">
                                                <Box
                                                    sx={{
                                                        ml: 2,
                                                        mr: 3,
                                                        [theme.breakpoints.down('md')]: {
                                                            mr: 2
                                                        }
                                                    }}
                                                >
                                                    <IconButton aria-label={notificationsLabel(userNotificationCount)} onClick={handleToggle}>
                                                        <Badge
                                                            ref={anchorRef}
                                                            aria-controls={open ? 'menu-list-grow' : undefined}
                                                            aria-haspopup="true"
                                                            badgeContent={userNotificationCount}
                                                            color="error"
                                                        >
                                                            <IconBell stroke={1.5} />
                                                        </Badge>
                                                    </IconButton>
                                                </Box>

                                                <NotificationPopper />
                                            </div>
                                        </li>
                                    ) : (
                                        ''
                                    )}
                                    {/*======================= || END OF NOTIFICATION ||==========================*/}

                                    {/* <li className="nav-item">
                                        <a className="nav-link" href="/">
                                            <i className="fa-solid fa-envelope" />
                                        </a>
                                    </li>
                                    <li className="nav-item">
                                        <a className="nav-link search" href="/">
                                            <i className="fa-solid fa-magnifying-glass" />
                                        </a>
                                    </li> */}

                                    {/*=====GREEN ONLINE  STATUS SYMBOL ==========*/}
                                    {/*<li className="nav-item user-profile">*/}
                                    {/*    <a href="/" className="nav-link">*/}
                                    {/*        /!* <img src={avatarLogo} alt="avtar-img" /> *!/*/}
                                    {/*        <span className="bg-success user-status" />*/}
                                    {/*    </a>*/}
                                    {/*</li>*/}

                                    {(loginType === 'dashboard_admin' || loginType === 'portfolio_manager') &&
                                        <div className='margin-right15px'>
                                            <Link onClick={() => clickMainMenu()} className='btn-transparent bg-transparent'>Main Menu</Link>
                                        </div>
                                    }

                                    {loginType === 'advisor' &&
                                        <div className='margin-right15px'>
                                            <Link onClick={() => navigate("/advisor_all_personal")} className='btn-transparent bg-transparent'>Main Menu</Link>
                                        </div>
                                    }

                                    {(userId || loginType === 'client') &&
                                        <li>
                                            <Link className="dropdown-item font-size14px padding-right5px">
                                                {(userData?.first_name ?? '') + ' ' + (userData?.last_name ?? '')}
                                            </Link>
                                        </li>
                                    }


                                    <li className="nav-item dropdown user-profile margin-right20px">
                                        <Link
                                            className="nav-link dropdown-toggle"
                                            href="#"
                                            id="navbarDropdown"
                                            role="button"
                                            data-bs-toggle="dropdown"
                                            aria-expanded="false"
                                        >
                                            <img src={avatarLogo} alt="avtar-img" />
                                        </Link>
                                        <ul className="dropdown-menu min-width-1rem" aria-labelledby="navbarDropdown">
                                            {/* SHOW ONLY AFTER COMPANY LOGIN  */}

                                            {loginType === '5' ? (
                                                <>
                                                    <li>
                                                        <Link className="dropdown-item cursor-pointer" onClick={() => onClickComponent(1)}>
                                                            Home
                                                        </Link>
                                                    </li>

                                                    <li>
                                                        <Link className="dropdown-item cursor-pointer" onClick={() => onClickComponent(2)}>
                                                            Client
                                                        </Link>
                                                    </li>
                                                </>
                                            ) : null}


                                            {(loginType === 'dashboard_admin' || loginType === 'portfolio_manager' || loginType === 'client') &&
                                                <>
                                                    {/* <li>
                                                        <Link className="dropdown-item cursor-pointer" onClick={() => navigate('/kyc/client-accounts')}>
                                                            Clients
                                                        </Link>
                                                    </li> */}
                                                    <li>
                                                        <Link className="dropdown-item cursor-pointer" onClick={logout}>
                                                            Logout
                                                        </Link>
                                                    </li>
                                                </>
                                            }

                                            {(loginType === 'advisor') &&
                                                <>
                                                    {/* <li>
                                                        <Link className="dropdown-item cursor-pointer" onClick={() => navigate('/advisor_all_personal')}>
                                                            Clients
                                                        </Link>
                                                    </li> */}
                                                    <li>
                                                        <Link className="dropdown-item cursor-pointer" onClick={logout}>
                                                            Logout
                                                        </Link>
                                                    </li>
                                                </>
                                            }

                                            {(prevLoginType === 'dashboard_admin' || prevLoginType === 'portfolio_manager') && comingFromLink === 'client-list' ?
                                                <>
                                                    <li>
                                                        <Link className="dropdown-item cursor-pointer" onClick={navigateClientList}>
                                                            Client List
                                                        </Link>
                                                    </li>
                                                </>
                                                : null}

                                                {prevLoginType === 'portfolio_manager_admin' && comingFromLink === 'client-list' ?
                                                <>
                                                    <li>
                                                        <Link className="dropdown-item cursor-pointer" onClick={navigateAdminClientList}>
                                                            Client List
                                                        </Link>
                                                    </li>
                                                </>
                                                : null}
                                        </ul>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </nav >
            </header >

            {/* <AppBar position="static" sx={{ backgroundColor: '#525252' }}>
                <Container maxWidth="xl">
                    <Toolbar disableGutters>
                        <Typography variant="h6" noWrap component="div" sx={{ flexGrow: 1, mr: 2, display: { xs: 'flex', md: 'flex' } }}>
                            <img src={SmiLogo} alt="smi_logo" />
                        </Typography>

                        <Box sx={{ flexGrow: 0 }}>
                            <IconButton onClick={handleOpenUserMenu} sx={{ p: 0 }}>
                                <Avatar alt="Remy Sharp" src="/static/images/avatar/2.jpg" />
                            </IconButton>
                            <Menu
                                sx={{ mt: '45px' }}
                                id="menu-appbar"
                                anchorEl={anchorElUser}
                                anchorOrigin={{
                                    vertical: 'top',
                                    horizontal: 'right'
                                }}
                                keepMounted
                                transformOrigin={{
                                    vertical: 'top',
                                    horizontal: 'right'
                                }}
                                open={Boolean(anchorElUser)}
                                onClose={handleCloseUserMenu}
                            >
                                {settings.map((setting) => (
                                    <MenuItem key={setting} onClick={handleCloseUserMenu}>
                                        <Typography textAlign="center" onClick={logOut}>
                                            {setting}
                                        </Typography>
                                    </MenuItem>
                                ))}
                            </Menu>
                        </Box>
                    </Toolbar>
                </Container>
            </AppBar> */}
        </>
    );
};
export default HeaderLayout;
